import { Inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError, filter, first, switchMap, tap } from 'rxjs/operators';
import { SharedFacadeInterface } from '@ellf/app-common';
import { BaseDbDto } from '@ellf/common-dto';

@Injectable()
export class BaseLoadAllGuard<T extends BaseDbDto> {
  constructor(
    @Inject('SharedEntityFacade')
    private sharedFacade: SharedFacadeInterface<T>,
  ) {}

  canActivate(): Observable<boolean> {
    return this.checkLoaded().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false)),
    );
  }

  checkLoaded(): Observable<boolean> {
    return this.sharedFacade.loadedAll$.pipe(
      tap((loaded) => {
        if (!loaded) {
          this.sharedFacade.loadAll();
        }
      }),
      filter((loaded) => loaded),
      first(),
    );
  }
}
